import React from 'react'
import { useTranslation } from 'react-i18next'
import { getFlaggedColor } from 'srcReact/helpers/utils'
import { redirectToPage } from 'srcReact/helpers/history'
import ReviewActionButton from 'srcReact/components/common2/ReviewActionButton'

function ReviewButtons({ reviewGroups, reviewWorkplaces, isNative, isMobile }) {
  const { t } = useTranslation()
  return (
    <div>
      {reviewGroups?.group_flag_count >= 1 && (
        <ReviewActionButton
          iconName='flag-icon'
          text={t('moderationReport.flaggedContentItem', {
            count: reviewGroups.group_flag_count,
            item: reviewGroups.group_flag_count > 1 ? t('moderationReport.items') : t('moderationReport.item')
          })}
          color={getFlaggedColor(reviewGroups.group_flag_count)}
          handleClick={() => redirectToPage(`/0/moderation?tab=awaiting_review`, isNative)}
        />
      )}
      {reviewWorkplaces?.total_count > 0 && (
        <ReviewActionButton
          iconName='send'
          text={t('moderationReport.workplaceInvitation', {
            count: reviewWorkplaces.total_count
          })}
          color='green'
          handleClick={() => {
            const workplaceId = reviewWorkplaces.count_per_workplace[0].workplace_id
            const path =
              isMobile || isNative
                ? `/0/workplace/manage-invites/${workplaceId}`
                : `/0/workplace/settings/${workplaceId}?section=link_3`
            redirectToPage(path, isNative)
          }}
        />
      )}
    </div>
  )
}

export default ReviewButtons
